import React, { PropsWithChildren, useState, useEffect } from 'react';
import { View, StyleProp, ViewStyle, Text, Pressable, useWindowDimensions, Platform, TextStyle, Animated } from 'react-native';
import IconArrowNext from '../source/icons/arrow-next';
import {GlobalVariables} from '../utils/globalVariables';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import IconDownload from '../source/icons/download';
import BackgroundLinear from './backgroundLinear';
import { SvgProps } from 'react-native-svg';

export enum enumTypesButtonComponent {
  primaryButton = 'primary',
  secondaryButton = 'secondary',
  auxiliarButton = 'auxiliar',
  primaryLink = 'primary-link'
}
export enum enumIconButtonComponent {
  arrowNext = 'arrow-next',
  arrowBack = 'arrow-back',
  download = 'download'
}
type SectionProps = PropsWithChildren<{
  icon?: enumIconButtonComponent,
  style?: StyleProp<ViewStyle>,
  text: string,
  type: enumTypesButtonComponent,
  disabled?: boolean,
  onPressButton?: any,
  styleText?: StyleProp<TextStyle>,
  styleIcon?: StyleProp<SvgProps>
}>;

function ButtonComponent({ icon, style, text, type, disabled = false, onPressButton, styleText, styleIcon }: SectionProps): JSX.Element {
  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout);
  const [statePressable, setStatePessable] = useState('');
  const [animatedX] = useState(new Animated.Value(0));
  useEffect(()=>{
    if (icon && icon === enumIconButtonComponent.arrowNext || icon && icon === enumIconButtonComponent.arrowBack) {
      let value =
        statePressable === 'hovered' && icon === enumIconButtonComponent.arrowNext ? 70
        : statePressable === 'hovered' && icon === enumIconButtonComponent.arrowBack ? -70 : 0;
      Animated.timing(animatedX, {
        toValue: value,
        duration: 200,
        useNativeDriver: true,
      }).start();
    }
  },[statePressable, icon, animatedX]);
  let SrcIcon = IconArrowNext;
  switch (icon) {
    case enumIconButtonComponent.arrowNext:
    case enumIconButtonComponent.arrowBack:
      SrcIcon = IconArrowNext;
      break;
    case enumIconButtonComponent.download:
      SrcIcon = IconDownload;
      break;
  }
  const getBackgroundColor = (colorFrom:boolean): string => {
    let color =
        (type === enumTypesButtonComponent.primaryButton && statePressable === 'hovered' && colorFrom) || (type === enumTypesButtonComponent.primaryButton && statePressable === 'pressed' && colorFrom) ?      '#4B93D0'
        : (type === enumTypesButtonComponent.primaryButton && statePressable === 'hovered' && !colorFrom) ||
        (type === enumTypesButtonComponent.primaryButton && statePressable === 'pressed' && !colorFrom) ?   '#3157A4'
        : (type === enumTypesButtonComponent.primaryButton && colorFrom) ||
          (type === enumTypesButtonComponent.auxiliarButton && statePressable === 'hovered' && colorFrom) ||
          (type === enumTypesButtonComponent.secondaryButton && statePressable === 'pressed' && colorFrom) ?
        '#FAB336'
        : (type === enumTypesButtonComponent.primaryButton && !colorFrom) ||
          (type === enumTypesButtonComponent.secondaryButton && statePressable === 'pressed' && !colorFrom) ||
          (type === enumTypesButtonComponent.auxiliarButton && statePressable === 'hovered' && !colorFrom) ?
        '#EE760C'
        : (type === enumTypesButtonComponent.secondaryButton && statePressable === 'hovered' && colorFrom) ?
        '#4B93D0'
        : (type === enumTypesButtonComponent.secondaryButton && statePressable === 'hovered' && !colorFrom) ?
        '#3157A4'
        : type === enumTypesButtonComponent.secondaryButton ?
        '#D4EDFC'
        : (type === enumTypesButtonComponent.auxiliarButton && colorFrom) ?
        '#4B93D0' : '#3157A4';
    return (!disabled) ? color : GlobalVariables.colors.secondary.lightGrey;
  };
  return (
    <Pressable
      disabled={disabled}
      onHoverIn={() => setStatePessable('hovered')}
      onHoverOut={() => setStatePessable('none')}
      onPressIn={() => setStatePessable('pressed')}
      onPressOut={() => setStatePessable('none')}
      onPress={() => {
			if (onPressButton) {
				onPressButton();
			}
      }}
      style={[
        styles('generalContainer'),
      ]}>
      <BackgroundLinear
        fromColor={getBackgroundColor(true)}
        toColor={getBackgroundColor(false)}
        style={[styles('backgroundLinear'), style]}>
        <Text style={[
          styles('text'),
          styleText,
          //Primary button
          type === enumTypesButtonComponent.primaryButton && statePressable === 'pressed' && styles('pressedPrimaryText'),
          //Secondary button
          type === enumTypesButtonComponent.secondaryButton && styles('secondaryText'),
          type === enumTypesButtonComponent.secondaryButton && statePressable === 'hovered' && styles('hoveredSecondaryText'),
          type === enumTypesButtonComponent.secondaryButton && statePressable === 'pressed' && styles('pressedSecondaryText'),
          disabled && {color: GlobalVariables.colors.secondary.white},
        ]}>
          {text}
        </Text>
        {
          icon ?
            <Animated.View style={{
              transform: [{translateX: animatedX}],
            }}>
              <View style={[
                styles('containerIcon'),
                icon === enumIconButtonComponent.arrowBack && styles('rotate')]}>
                <SrcIcon style={styleIcon} fill={
                  type === enumTypesButtonComponent.primaryButton && statePressable === 'pressed' ?
                    GlobalVariables.colors.primary.kingBlue :
                    type === enumTypesButtonComponent.secondaryButton && statePressable === 'hovered' ||
                      type === enumTypesButtonComponent.secondaryButton && statePressable === 'pressed' ?
                      GlobalVariables.colors.secondary.white :
                      type === enumTypesButtonComponent.secondaryButton ?
                        GlobalVariables.colors.primary.kingBlue : GlobalVariables.colors.secondary.white
                } />
              </View>
            </Animated.View>
            :
            null
        }
      </BackgroundLinear>
    </Pressable>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  generalContainer: {
  },
  backgroundLinear: {
    width: 160,
    height: 55,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: 40,
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  secondaryText: {
    color: GlobalVariables.colors.primary.kingBlue,
  },
  containerIcon: {
  },
  text: {
    fontSize: 19,
    fontWeight: '500',
    textAlign: 'center',
    color: GlobalVariables.colors.secondary.white,
    letterSpacing: 0.2,
    lineHeight: 20,
    fontFamily: '"Helvetica Neue LT Std 65 Medium", sans-serif',
  },
  icon: {
    width: 65,
    height: 85,
  },
  hoveredSecondaryText: {
    color: GlobalVariables.colors.secondary.white,
  },
  pressedPrimaryText: {
    color: GlobalVariables.colors.primary.kingBlue,
  },
  pressedSecondaryText: {
    color: GlobalVariables.colors.secondary.white,
  },
  rotate: {
    transform: [{ rotate: '180deg' }],
  },
}, {
  generalContainer: {
  },
  text: {
    fontSize: 16,
    ...Platform.select({
      android:{
        fontWeight: 'bold',
      },
    }),
  },
  backgroundLinear:{
    width: 135,
  },
});
export default ButtonComponent;
